
import BaseListItem from '@/components/base/BaseListItem'
import draggable from 'vuedraggable'
import UiIcon from '@/components/common/UiIcon.vue'
import {Component, Prop} from 'vue-property-decorator'

@Component({components: {draggable, UiIcon}})
export default class BaseListItemContainer extends BaseListItem {
  @Prop(Boolean) searchable!: boolean
  search = ''

  get items() {
    const data = this.data || []
    const query = this.normalize(this.search.trim())
    if (!query) return data
    return data.filter((item: any) =>
      this.normalize([item.LIBELLE, item.TEXTE, item.NOM, item.NOM_FICHIER].filter(Boolean).join(' ')).includes(query)
    )
  }

  normalize(value: string) {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
  }

  move(index: number, direction: number) {
    if (this.search || !this.isDraggable || index + direction < 0 || index + direction >= this.data.length) return
    const item = this.data.splice(index, 1)[0]
    this.data.splice(index + direction, 0, item)
    this.change()
  }

  change() {
    this.$emit('changeOrder', this.data)
  }
}
